exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drawer-container[data-v-126b135a] {\n  padding: 0.125rem;\n  font-size: 0.072917rem;\n  line-height: 1.5;\n  word-wrap: break-word;\n}\n.drawer-container .drawer-title[data-v-126b135a] {\n  margin-bottom: 0.0625rem;\n  color: rgba(0,0,0,.85);\n  font-size: 0.072917rem;\n  line-height: 0.114583rem;\n}\n.drawer-container .drawer-item[data-v-126b135a] {\n  color: rgba(0,0,0,.65);\n  font-size: 0.072917rem;\n  padding: 0.0625rem 0;\n}\n.drawer-container .drawer-switch[data-v-126b135a] {\n  float: right;\n}", ""]);

// exports
